export class LivestockClaim {
    id: string = '';    
    quote_id: string = '';  
    livestock_type_id: string = '';  
    claim_amount: number = null;  
    cover_claimed_for: number = null;  
}
